import type { AppMessages } from '../../types';

export const app: AppMessages = {
  common: {
    loading: 'Duke u ngarkuar...',
    saving: 'Duke ruajtur...',
    save: 'Ruaj',
    back: 'Kthehu',
    error: 'Gabim',
    notSet: 'E papërcaktuar',
    user: 'Përdorues',
    system: 'Sistemi',
    copied: 'U kopjua!',
    copy: 'Kopjo',
    cancel: 'Anulo',
    creating: 'Duke krijuar...',
    processing: 'Duke përpunuar...',
    you: 'Ti',
    stars: 'Stars',
    seeAll: 'Shiko të gjitha',
    filter: 'Filtro',
    amount: 'Shuma',
    date: 'Data',
    details: 'Detajet',
    mustBeLoggedIn: 'Duhet të jesh i identifikuar',
    daysShort: 'd',
    hoursShort: 'orë',
    minutesShort: 'min',
    justNow: 'Tani',
    noTitle: 'Pa titull',
    payment: 'pagesë',
    payments: 'pagesa',
  },
  layout: {
    dashboard: 'Paneli',
    invoices: 'Faturat',
    ledger: 'Libri',
    withdraws: 'Tërheqjet',
    redirects: 'Ridrejtime',
    settings: 'Cilësimet',
    admin: 'Admin',
    profile: 'Profili',
    logout: 'Dil',
    tonConfigured: 'TON i konfiguruar',
    configureTon: 'Konfiguro TON',
    tonNotConfigured: 'Adresa TON nuk është konfiguruar',
    active: 'Aktiv',
    walletConnect: 'Lidh portofolin',
    walletTitle: 'Lidh portofolin tënd TON',
    walletSubtitle: 'Shkruaj adresën TON që do të marrë tërheqjet e tua.',
    walletConnectedTitle: 'Portofoli u lidh',
    walletConnectedSubtitle: 'Tërheqjet e tua do të dërgohen në këtë adresë.',
    walletCurrentAddress: 'Adresa e lidhur',
    walletAddressLabel: 'Adresa TON',
    walletHint: 'Pranohet formati user-friendly (EQ… / UQ…) ose raw (0:…).',
    walletInvalidAddress: 'Adresë TON e pavlefshme',
    walletUpdate: 'Përditëso adresën',
    walletChangeAddress: 'Ndrysho adresën',
    walletDisconnect: 'Shkëput',
    walletDisconnectConfirmTitle: 'Të shkëputet portofoli?',
    walletDisconnectConfirmBody: 'Nuk do të mund të kërkosh tërheqje derisa të lidhësh një adresë të re.',
    walletSaved: 'Portofoli u lidh me sukses',
    walletDisconnected: 'Portofoli u shkëput',
    newPaymentLink: 'Lidhje e re pagese',
    openBot: 'Boti Telegram',
    helpCenter: 'Qendra e ndihmës',
  },
  login: {
    seoTitle: 'Identifikohu | Platforma e pagesave Telegram Stars',
    seoDescription: 'Identifikohu në llogarinë tënde Telegram Stars Payment Platform',
    signIn: 'Identifikohu',
    signUp: 'Regjistrohu',
    email: 'Email',
    password: 'Fjalëkalimi',
    displayNameOptional: 'Emri i shfaqur (opsional)',
    displayNamePlaceholder: 'Emri yt',
    emailPlaceholder: 'emaili@example.com',
    signInButton: 'Identifikohu',
    signUpButton: 'Regjistrohu',
    signInWithGoogle: 'Identifikohu me Google',
    or: 'OSE',
    welcome: 'Mirë se vjen',
    subtitle: 'Identifikohu ose krijo një llogari për të filluar',
    minPasswordHint: 'Minimumi 6 karaktere',
    tipTelegram: '💡 Këshillë: mund ta lidhësh llogarinë tënde Telegram te cilësimet pas regjistrimit',
    continueWithTelegram: 'Vazhdo me Telegram',
    telegramAuthError: 'Hyrja me Telegram dështoi. Provo përsëri.',
    featureInstant: 'Krijim i menjëhershëm i llogarisë',
    featureManage: 'Menaxho pagesat e tua Telegram Stars',
    featureWithdraw: 'Tërhiq fondet e tua në TON',
    emailRequired: 'Shkruaj email-in tënd',
    emailInvalid: 'Format email i pavlefshëm',
    passwordRequired: 'Shkruaj fjalëkalimin tënd',
    passwordRequiredSignup: 'Shkruaj një fjalëkalim',
    passwordMinLength: 'Fjalëkalimi duhet të ketë të paktën 6 karaktere',
    genericError: 'Ndodhi një gabim',
    recaptchaFailed: 'Verifikimi reCAPTCHA dështoi. Provo përsëri.',
    invalidCredentials: 'Email ose fjalëkalim i gabuar. Nëse nuk ke llogari ende, krijo një te skeda «Regjistrohu».',
    wrongPassword: 'Fjalëkalim i gabuar. Kontrollo fjalëkalimin.',
    tooManyAttempts: 'Shumë përpjekje. Provo përsëri më vonë.',
    accountDisabled: 'Kjo llogari është çaktivizuar. Kontakto mbështetjen.',
    authNotEnabled: 'Autentifikimi me email/fjalëkalim nuk është aktiv. Kontrollo konfigurimin Firebase.',
    emailInUse: 'Ky email përdoret tashmë. Identifikohu me këtë email.',
    googleAuthError: 'Ndodhi një gabim gjatë autentifikimit me Google',
    popupClosed: 'Dritarja u mbyll. Provo përsëri.',
    popupBlocked: 'Dritarja u bllokua. Lejo dritaret popup dhe provo përsëri.',
    popupCancelled: 'Lejohet vetëm një kërkesë popup në të njëjtën kohë.',
  },
  dashboard: {
    loading: 'Duke ngarkuar panelin...',
    overallSummary: 'Përmbledhje e përgjithshme',
    lastMonth: 'Muaji i kaluar',
    lastWeek: 'Java e kaluar',
    lastYear: 'Viti i kaluar',
    balance: 'Bilanci',
    available: 'I disponueshëm',
    totalEarned: 'Totali i fituar',
    fromLastMonth: 'krahasuar me muajin e kaluar',
    recentPayments: 'Pagesat e fundit',
    last7days: '7 ditët e fundit',
    last30days: '30 ditët e fundit',
    quickActions: 'Veprime të shpejta',
    createLink: 'Krijo lidhje',
    createLinkDesc: 'Gjenero një lidhje të re pagese',
    withdraw: 'Tërhiq',
    withdrawDesc: 'Tërhiq Stars në TON',
    invoices: 'Faturat',
    invoicesDesc: 'Shiko historinë e pagesave',
    ledger: 'Libri',
    ledgerDesc: 'Shiko të gjitha transaksionet',
    recentActivity: 'Aktiviteti i fundit',
    noRecentActivity: 'Pa aktivitet të fundit',
    mostRecent: 'Më të fundit',
    noRecentInvoices: 'Pa fatura të fundit',
    allInvoices: 'Të gjitha faturat',
    paymentReceived: 'Pagesë e marrë: {title}',
    withdrawalRequested: 'Tërheqje e kërkuar: {amount} {suffix}',
    transaction: 'Transaksion: {amount} {suffix}',
    invoiceLabel: 'Fatura #{id}',
    failedLoadBalance: 'Dështoi ngarkimi i bilancit',
    chartAmount: 'Shuma',
  },
  invoices: {
    loading: 'Duke u ngarkuar...',
    allInvoices: 'Të gjitha faturat',
    paid: 'Të paguara',
    sent: 'Të dërguara',
    created: 'Të krijuara',
    expired: 'Të skaduara',
    filter: 'Filtro',
    createInvoice: '+ Krijo faturë',
    noInvoices: 'Nuk u gjetën fatura',
    relatedTo: 'Lidhur me:',
    paymentMode: 'Pagesë {mode}',
    copyLink: 'Kopjo lidhjen',
    copyLinkTitle: 'Kopjo lidhjen e faturës',
    linkNotAvailable: 'Lidhja e faturës nuk është e disponueshme',
    linkCopied: 'Lidhja e faturës u kopjua në clipboard!',
    copyFailed: 'Dështoi kopjimi i lidhjes',
    failedLoad: 'Dështoi ngarkimi i faturave',
    statusPaid: 'e paguar',
    statusSent: 'e dërguar',
    statusCreated: 'e krijuar',
    statusExpired: 'e skaduar',
    typeSingleUse: 'përdorim i vetëm',
    typeRecurring: 'periodike',
  },
  createInvoice: {
    back: 'Kthehu',
    title: 'Krijo një lidhje pagese',
    subtitle: 'Gjenero një lidhje të re pagese në sekonda',
    successTitle: 'Lidhja e pagesës u krijua!',
    successSubtitle: 'Lidhja e pagesës është gati për ndarje',
    paymentLink: 'Lidhja e pagesës:',
    integrationTitle: 'Integro këtë lidhje në faqen tënde',
    integrationDesc: 'Boti ynë Telegram të udhëzon hap pas hapi (API, buton HTML, ridrejtime).',
    openTutorial: 'Hap udhëzuesin',
    testLink: 'Testo lidhjen',
    viewInvoices: 'Shiko faturat e mia',
    createNew: 'Krijo një lidhje të re',
    shareTelegram: 'Shpërndaje në Telegram',
    paymentMode: 'Mënyra e pagesës',
    modeStars: 'Stars',
    modeEur: 'EUR (€)',
    modeUsd: 'USD ($)',
    amountInteger: 'Shuma (numër i plotë)',
    amountDecimal: 'Shuma (dhjetore)',
    amountRequired: 'Shkruaj një shumë',
    amountIntegerError: 'Shuma duhet të jetë numër i plotë më i madh se 0',
    amountNoDecimals: 'Shuma në Stars duhet të jetë numër i plotë (pa dhjetore)',
    amountMustBeInteger: 'Shuma në Stars duhet të jetë numër i plotë',
    amountGreaterThanZero: 'Shuma duhet të jetë më e madhe se 0',
    titleOptional: 'Titulli (opsional)',
    titlePlaceholder: 'Titulli i pagesës (p.sh. Pagesë për shërbime)',
    descriptionOptional: 'Përshkrimi (opsional)',
    descriptionPlaceholder: 'Përshkrim i detajuar i pagesës...',
    singleUse: 'Lidhje me përdorim të vetëm',
    singleUseTooltip: 'Nëse aktivizohet, kjo lidhje mund të përdoret vetëm një herë. Pas pagesës nuk do të jetë më e vlefshme.',
    createLink: 'Krijo lidhje',
    cancel: 'Anulo',
    invalidAmount: 'Shumë e pavlefshme',
    starsMustBeInteger: 'Shuma duhet të jetë numër i plotë për Stars',
    createError: 'Gabim gjatë krijimit të faturës',
  },
  ledger: {
    title: 'Libri',
    typeColumn: 'Lloji',
    description: 'Historiku i plotë i të gjitha transaksioneve të tua',
    loading: 'Duke u ngarkuar...',
    noEntries: 'Asnjë transaksion për momentin.',
    typePayment: 'Pagesë',
    typeFee: 'Komision',
    typeNetPayment: 'Pagesë neto',
    typeWithdrawal: 'Tërheqje',
    typeAdjustment: 'Rregullim',
    amountStars: 'Shuma (Stars)',
    invoiceDetail: 'Fatura: {title} ({amount} Stars)',
    paidBy: 'Paguar nga: {payer}',
    payerId: '(ID: {id})',
    withdrawDetail: 'Tërheqje: {amount} Stars (Statusi: {status})',
    failedLoad: 'Dështoi ngarkimi i librit',
  },
  withdraws: {
    title: 'Kërkesat e mia për tërheqje',
    newRequest: '+ Kërkesë e re',
    totalLedger: 'Totali i librit',
    available: 'I disponueshëm',
    pendingWithdrawals: 'Tërheqje në pritje',
    hold21days: 'Bllokim 21 ditë',
    payoutNote: 'Pagesat përpunohen manualisht nga një admin. Aplikohet një komision 3% gjatë tërheqjes.',
    forecastTitle: 'Parashikimi i tërheqjeve',
    loadingForecast: 'Duke ngarkuar parashikimin...',
    noForecast: 'Pa data të ardhshme tërheqjeje',
    paymentsCount: '({count} pagesa)',
    noRequests: 'Asnjë kërkesë tërheqjeje për momentin.',
    createFirst: 'Krijo kërkesën tënde të parë',
    amount: 'Shuma:',
    destination: 'Destinacioni:',
    processedOn: 'Përpunuar më:',
    externalRef: 'Referenca e jashtme:',
    errorLabel: 'Gabim:',
    rejectionReason: 'Arsyeja e refuzimit:',
    failedLoad: 'Dështoi ngarkimi i tërheqjeve',
    loading: 'Duke u ngarkuar...',
  },
  createWithdraw: {
    title: 'Kërko një tërheqje',
    balanceSource: 'Bilanci (burimi: libri backend)',
    available: 'I disponueshëm: {amount} Stars',
    pending: 'Tërheqje në pritje: {amount} Stars',
    waiting: 'Bllokim 21 ditë: {amount} Stars',
    minAndFee: 'Tërheqje minimale: {min} Stars · Komision platforme: 3% gjatë pagesës (përpunim manual)',
    amountLabel: 'Shuma (Stars)',
    minPlaceholder: 'Minimumi: {min}',
    feeHint: 'Bruto: {gross} Stars · Komision (3%): {fee} Stars · Merr: {net} Stars',
    useRegistered: 'Përdor adresën time TON të regjistruar',
    registeredAddress: 'Adresa e regjistruar:',
    tonDestination: 'Adresa e destinacionit TON',
    tonPlaceholder: 'EQAbc123...',
    tonFormatHint: 'Formati: EQ... ose 0:... (base64 ose hex)',
    createRequest: 'Krijo kërkesë',
    cancel: 'Anulo',
    creating: 'Duke krijuar...',
    insufficientBalance: '⚠️ Bilanc i pamjaftueshëm për tërheqje (minimumi: {min} Stars)',
    amountMustBeInteger: 'Shuma duhet të jetë numër i plotë pozitiv',
    createError: 'Gabim gjatë krijimit të kërkesës për tërheqje',
  },
  redirects: {
    title: 'Lidhjet e ridrejtimit',
    description: 'Krijo lidhje të shkurtra që ridrejtojnë te një URL sipas zgjedhjes tënde. Ndarja e lidhjes /r/slug-u yt do t\'i dërgojë vizitorët te URL-ja e konfiguruar.',
    newRedirect: 'Ridrejtim i ri',
    clicks: 'klikime',
    unique: 'unike',
    links: 'lidhje',
    modalTitle: 'Ridrejtim i ri',
    slugLabel: 'Slug (identifikuesi i lidhjes)',
    slugRequired: 'Fushë e detyrueshme',
    slugPattern: 'Vetëm shkronja, numra, viza dhe nënviza',
    slugMax: 'Maks. 64 karaktere',
    slugReserved: 'Ky slug është i rezervuar. Zgjidh një tjetër.',
    slugPlaceholder: 'p.sh.: faqja-ime',
    urlLabel: 'URL e destinacionit',
    urlInvalid: 'URL e pavlefshme',
    urlHttpOnly: 'Pranohen vetëm URL http dhe https.',
    urlTooLong: 'URL shumë e gjatë (maks. 2048 karaktere).',
    urlPlaceholder: 'https://example.com/page',
    createButton: 'Krijo ridrejtim',
    loading: 'Duke u ngarkuar…',
    empty: 'Pa ridrejtime. Kliko «Ridrejtim i ri» për të krijuar një.',
    copyLink: 'Kopjo lidhjen',
    linkCopied: 'Lidhja u kopjua',
    deleteTitle: 'Të fshihet ky ridrejtim?',
    yes: 'Po',
    no: 'Jo',
    delete: 'Fshi',
    totalClicks: 'Totali i klikimeve',
    uniqueClicks: 'Klikime unike',
    avgClicks: 'Mes. klikime/vizitor',
    loadError: 'Gabim gjatë ngarkimit të ridrejtimit',
    createSuccess: 'Lidhja e ridrejtimit u krijua',
    createError: 'Gabim gjatë krijimit të ridrejtimit',
    deleteSuccess: 'Ridrejtimi u fshi',
    deleteError: 'Gabim gjatë fshirjes së ridrejtimit',
  },
  adminWithdraws: {
    title: 'Administrimi - Kërkesat për tërheqje',
    filterByStatus: 'Filtro sipas statusit:',
    all: 'Të gjitha',
    noRequests: 'Asnjë kërkesë për këtë status.',
    agent: 'Agjenti:',
    amount: 'Shuma:',
    destination: 'Destinacioni:',
    processedOn: 'Përpunuar më:',
    externalRef: 'Ref. e jashtme:',
    errorLabel: 'Gabim:',
    reason: 'Arsyeja:',
    approve: '✓ Aprovo',
    reject: '✗ Refuzo',
    markPaid: '✓ Shëno si paguar',
    markFailed: '✗ Shëno si dështuar',
    approveConfirm: 'Të aprovohet kjo kërkesë tërheqjeje?',
    rejectPrompt: 'Arsyeja e refuzimit:',
    markPaidPrompt: 'Referenca e jashtme e pagesës (e detyrueshme — hash tx TON, ref. bankare, etj.):',
    markPaidRequired: 'externalRef kërkohet për të konfirmuar një pagesë manuale.',
    markFailedPrompt: 'Mesazhi i gabimit:',
    approveError: 'Gabim gjatë aprovimit të tërheqjes',
    rejectError: 'Gabim gjatë refuzimit të tërheqjes',
    updateError: 'Gabim gjatë përditësimit',
    failedLoad: 'Dështoi ngarkimi i tërheqjeve',
    notAuthenticated: 'Jo i identifikuar',
    operationFailed: 'Operacioni dështoi',
    loading: 'Duke u ngarkuar...',
  },
  redirectResolve: {
    missingSlug: 'Mungon slug',
    invalidLink: 'Lidhje e pavlefshme',
    notFound: 'Lidhja nuk u gjet',
    notFoundTitle: 'Lidhja nuk u gjet',
    redirecting: 'Duke ridrejtuar...',
    redirectTitle: 'Ridrejtim',
  },
  errorBoundary: {
    title: 'Ndodhi një gabim',
    subtitle: 'Na vjen keq, diçka shkoi keq. Provo përsëri.',
    goHome: 'Kthehu në faqen kryesore',
    reload: 'Ringarko faqen',
    devDetails: 'Detajet e gabimit (vetëm dev):',
  },
};

export const settingsApp = {
  eyebrow: 'CILËSIMET',
  profile: 'Profili',
  email: 'Email',
  telegramId: 'ID Telegram',
  notLinked: 'Jo i lidhur',
  linking: 'Duke lidhur...',
  linkTelegram: 'Lidh llogarinë time Telegram',
  openFromTelegram: '⚠️ Hape këtë faqe nga Telegram për të lidhur llogarinë',
  displayName: 'Emri i shfaqur',
  displayNameHint: 'Emri i shfaqur vendoset gjatë krijimit të llogarisë',
  withdrawal: 'Tërheqje',
  tonAddress: 'Adresa e destinacionit TON',
  tonAddressPlaceholder: 'EQAbc123... ose 0:...',
  tonAddressHint: 'Kjo adresë do të përdoret si parazgjedhje për tërheqjet e tua',
  tonUpdated: 'Adresa TON u përditësua me sukses',
  about: 'Rreth',
  commission: 'Komisioni i platformës:',
  commissionValue: '3% për çdo pagesë',
  minWithdrawal: 'Tërheqje minimale:',
  minWithdrawalValue: '100 Stars',
  starsCurrency: 'Monedha Stars:',
  starsCurrencyValue: 'XTR',
  telegramWebAppNotAvailable: 'Telegram WebApp nuk është i disponueshëm. Hape këtë faqe nga Telegram.',
  telegramUserDataNotAvailable: 'Të dhënat e përdoruesit Telegram nuk janë të disponueshme.',
  telegramLinked: 'Llogaria Telegram u lidh me sukses!',
  linkTelegramError: 'Gabim gjatë lidhjes së llogarisë Telegram',
  updateError: 'Gabim gjatë përditësimit',
  mustBeLoggedIn: 'Duhet të jesh i identifikuar',
};
